import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

import {
  Box, Columns, LoadingModule,
} from '@domain-group/suit-theme'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageHeader from '@components/PageHeader'

import ProviderDeadlinesGroup from '../ProviderDeadlinesGroup'
import ProviderDeadlinesBlankState from '../ProviderDeadlinesBlankState'
import generateDeadlineTabItems from '../../../../components/utils/generateDeadlineTabItems'

import useProviderDeadlines from '../../hooks/useProviderDeadlines'

const PageContent = () => {
  useLocation()

  const useProviderDeadlinesPayload = useProviderDeadlines()
  const {
    agencyDeadlines,
    agencyIdParam,
    callbacks,
    hasProviderDeadlines,
    loading,
    providers,
  } = useProviderDeadlinesPayload

  return (
    <>
      <Helmet>
        <title>Deadlines | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="provider-deadlines"
        nestedNavigation
        // @ts-expect-error TS2345
        tabBarItems={generateDeadlineTabItems(agencyIdParam)}
        title="Provider Deadlines"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation
              locationKey="agency.agencyDashboard.deadlines.banner"
            />

            {/*
             // @ts-expect-error TS2322 */}
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasProviderDeadlines && <ProviderDeadlinesBlankState />}

            {Object.values(providers)
              // @ts-expect-error TS2769
              .filter(provider => Object.keys(provider.deadlines).length > 0)
              .map(provider => (
                <ProviderDeadlinesGroup
                  agencyDeadlines={agencyDeadlines}
                  callbacks={callbacks}
                  key={provider.id}
                  provider={provider}
                />
              ))}
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation
              locationKey="agency.agencyDashboard.deadlines.sidebar"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
